import { useQuery, useInfiniteQuery } from '@tanstack/react-query';

import { Notification } from './notification.type';
import { getNotifications, getUnreadCount } from './notification.api';

export const NOTIFICATIONS_QUERY_KEY = 'notifications';
export const NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY = 'notifications-unread-count';

export function useInfiniteNotifications() {
  const { data, error, fetchNextPage, hasNextPage, isFetchingNextPage, status, refetch, isLoading } = useInfiniteQuery({
    queryKey: [NOTIFICATIONS_QUERY_KEY],
    queryFn: ({ pageParam = 1 }) => getNotifications({ page: pageParam, limit: 10 }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 1,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
  // Flatten the pages into a single array of notifications
  const notifications: Notification[] = data?.pages.flatMap((page) => page.notifications) || [];

  return {
    notifications,
    error,
    fetchNextPage,
    hasNextPage: !!hasNextPage,
    isFetchingNextPage,
    status,
    refetch,
    isLoading,
  };
}

export const useUnreadCount = () =>
  useQuery({
    queryKey: [NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY],
    queryFn: getUnreadCount,
    staleTime: 30 * 1000,
  });
